import React from 'react';

const AudioContext = React.createContext(null);

export default AudioContext;